export const noDataElement = `
  bg-ll-surface px-3 pt-4 pb-3 rounded-sm box-border
`;

export const spinner = `
  flex justify-center items-center 
  px-3 pt-4 pb-3 height-[40px]
`;
